import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJapan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_697)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#F0F0F0"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12 17.2174C14.8815 17.2174 17.2174 14.8815 17.2174 12C17.2174 9.11852 14.8815 6.78262 12 6.78262C9.11855 6.78262 6.78265 9.11852 6.78265 12C6.78265 14.8815 9.11855 17.2174 12 17.2174Z",
			fill: "#D80027"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_697",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgJapan;
